import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertasService } from 'src/app/core/_services/alerta.service';
import { CoreService } from 'src/app/core/_services/core.services';
import { CONSTANTES_SESION } from 'src/app/core/_util/services-util';

@Component({
  selector: 'app-recepcion-tk',
  templateUrl: './recepcion-tk.component.html',
  styleUrls: ['./recepcion-tk.component.scss']
})
export class RecepcionTkComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private coreService: CoreService,
    private msj: AlertasService
  ) {
  }

  ngOnInit(): void {
    this.guardarToken();
  }

  guardarToken() {
    sessionStorage.setItem(CONSTANTES_SESION.TOKEN, 'CRM:' + this.route.snapshot.queryParams.token);
    this.coreService.post('/user-info', null).subscribe(
      (res: any) => {
        sessionStorage.setItem(CONSTANTES_SESION.NOMBRE, res.name);
        sessionStorage.setItem(CONSTANTES_SESION.USERNAME, res.username)
        this.redirigir(this.route.snapshot.queryParams.nombre, this.route.snapshot.queryParams.id);
      },
      (err: any) => {
        this.router.navigate(['/']);
        this.msj.error('No se pudo recuperar la información del usuario');
      }
    )
  }

  redirigir(opcion, id) {
    if (opcion === 'Ejecutar Evaluación') {
      this.router.navigate(['/evaluacion-competencias']);
    } else if (opcion === 'Nueva Ficha') {
      this.router.navigate(['/ficha']);
    } else if (opcion === 'Generar Consultas') {
      this.router.navigate(['/consultas']);
    } else if (opcion === 'Reclutamiento Candidato') {
      this.router.navigate(['/filtro-candidatos']);
    } else if (opcion === 'Reclutamiento Head Hunter') {
      this.router.navigate(['/head-hunter']);
    } else if (opcion === 'Hoja Vida Candidato') {
      this.router.navigate(['/hoja-vida-candidato/' + this.route.snapshot.queryParams.id + '/' + this.route.snapshot.queryParams.numero_id]);
    } else if (opcion === 'Crear Requerimiento Cliente') {
      this.router.navigate(['/crear-requerimiento-cargo-cliente']);
    } else if (opcion === 'Crear Requerimiento Head Hunter') {
      this.router.navigate(['/req-head-hunter']);
    } else if (opcion === 'Editar Ficha') {
      this.router.navigateByUrl('/ficha?id=' + id);
    } else if (opcion === 'Volumen de Datos') {
      this.router.navigate(['/volumen-datos']);
    } else if (opcion === 'Ejecutar Consultas') {
      this.router.navigate(['/ejecutar-consulta']);
    } else if (opcion === 'Proceso Candidato') {
      this.router.navigate(['/estado-proceso']);
    } else if (opcion === 'Proceso Contratacion') {
      this.router.navigate(['/proceso-contratacion']);
    } else if (opcion === 'Solicitudes Backend') {
      this.router.navigate(['/solicitudes-backend']);
    } else {
      this.router.navigate(['/']);
    }
  }
}